__turbopack_context__.v({
  "autoCompleteOptionContainer": "lUFewq_autoCompleteOptionContainer",
  "clearButton": "lUFewq_clearButton",
  "comboBox": "lUFewq_comboBox",
  "comboBoxContainer": "lUFewq_comboBoxContainer",
  "iconContainer": "lUFewq_iconContainer",
  "link": "lUFewq_link",
  "textOverflowWrapper": "lUFewq_textOverflowWrapper",
  "textWrapper": "lUFewq_textWrapper",
});
